@if (filteredAutocompleteList$ | async; as filteredAutocompleteList) {
  @if (filteredAutocompleteList?.length) {
    <div
      appDropdown
      [withNavigation]="true"
      [info]="showDropdownInfo"
      [holdDownSiblingsSelector]="holdDownSiblingsSelector"
      [holdDownSiblingsClass]="holdDownSiblingsClass"
      (hideOnClickOutside)="clickHideDropdownOnClickOutside()"
      class="dropdown {{ sizeType }}"
      tabindex="0">
      @if (sizeType === 'standard') {
        <h6 class="dropdown__heading">
          {{ 'SEARCH.YOU_MAY_LOOKING_FOR' | translate }}
        </h6>
      }
      <div class="scroll-wrapper vertical">
        <app-scrollbar class="scrollbar" [vertical]="true" [size]="'small'">
          <span class="dropdown__items">
            @for (item of filteredAutocompleteList; track item) {
              <span
                appDropdownItem
                (click)="clickSetItem($event, item)"
                [active]="item.active"
                class="user-tags-dropdown-item dropdown__item">
                <span class="dropdown__item-text">
                  {{ item.name }}
                </span>
              </span>
            }
          </span>
        </app-scrollbar>
      </div>
    </div>
  }
}
